import './ThemeLoader.css';

interface ThemeLoaderProps {
  text?: string;
}

export default function ThemeLoader({ text = 'Loading' }: ThemeLoaderProps) {
  return (
    <div className="theme-loader-state">
      <div className="theme-loader">
        <div className="theme-loader-dot"></div>
        <div className="theme-loader-dot"></div>
        <div className="theme-loader-dot"></div>
      </div>
      <p>{text}</p>
    </div>
  );
}
